import React from "react";
import { generatedBusinessPlatformRoadmap } from "../data/generatedBusinessPlatformRoadmap.js";
import { CellStack, DataTable, EvidencePanel, MetricGrid, PageHeader, StatusPill } from "../components/ui.jsx";

export function PlatformRoadmap() {
  const roadmap = generatedBusinessPlatformRoadmap;
  return (
    <section className="module">
      <PageHeader
        title="PLATFORM ROADMAP"
        muted="Business operating plan"
        subtitle="Hash-backed capability plan for the Interplanetary Industrial Feasibility Intelligence Platform."
      />
      <MetricGrid
        metrics={[
          { label: "Roadmap hash", value: roadmap.roadmapHash.slice(0, 18) },
          { label: "Capabilities", value: roadmap.capabilityCount },
          { label: "Blocked tracks", value: roadmap.blockedCapabilityCount },
          { label: "Source refs", value: roadmap.sourceReferenceCount },
          { label: "Phases", value: roadmap.phaseCount },
          { label: "Customer use", value: roadmap.customerUseAllowed ? "allowed" : "blocked" },
          { label: "Commercial use", value: roadmap.commercialUseAllowed ? "allowed" : "blocked" },
          { label: "Markdown", value: roadmap.markdownHash.slice(0, 18) },
        ]}
      />
      <EvidencePanel title="Business wedge" status={roadmap.mode} className="panel-large">
        <p>{roadmap.businessWedge}</p>
        <p>{roadmap.releaseImpact}</p>
      </EvidencePanel>
      <EvidencePanel title="Capability tracks" status="fail closed" className="panel-large">
        <DataTable
          columns={[
            {
              key: "capability",
              header: "Capability",
              render: (capability) => <CellStack title={capability.label} meta={capability.id} />,
            },
            { key: "phase", header: "Phase" },
            {
              key: "readiness",
              header: "Readiness",
              render: (capability) => (
                <StatusPill tone={capability.blockers.length ? "amber" : "green"}>
                  {capability.readinessState}
                </StatusPill>
              ),
            },
            { key: "customerValue", header: "Customer value" },
            {
              key: "blockers",
              header: "Blockers",
              render: (capability) => capability.blockers.join(" | "),
            },
            {
              key: "nextAction",
              header: "Next action",
              render: (capability) => capability.nextBuildActions[0],
            },
            {
              key: "hash",
              header: "Hash",
              render: (capability) => <code>{capability.capabilityHash.slice(0, 18)}</code>,
            },
          ]}
          rows={roadmap.capabilities}
          getRowKey={(capability) => capability.id}
        />
      </EvidencePanel>
      <div className="module-grid">
        <EvidencePanel title="Phase gates" status={`${roadmap.phaseCount} phases`} tone="blue">
          <div className="stack-list">
            {roadmap.phasePlan.map((phase) => (
              <div className="stack-item" key={phase.id}>
                <strong>{phase.label}</strong>
                <span>{phase.entryState}</span>
                <p>{phase.exitCriteria.join(" | ")}</p>
              </div>
            ))}
          </div>
        </EvidencePanel>
        <EvidencePanel title="Source families" status={`${roadmap.sourceReferenceCount} references`} tone="blue">
          <div className="stack-list">
            {roadmap.sourceReferences.slice(0, 8).map((source) => (
              <div className="stack-item" key={source.id}>
                <strong>{source.title}</strong>
                <span>{source.sourceType}</span>
                <p>{source.plannedUse}</p>
              </div>
            ))}
          </div>
        </EvidencePanel>
      </div>
    </section>
  );
}
